import ServiceCRUD from '../../../services/ServiceCRUDFLEXCHAT';
import { apiChat as http, apiChatTS } from '../../../http/index';
class ConversationReportService extends ServiceCRUD {
  constructor() {
    super('configuracao/api');
  }

  getwhatsappNumber() {
    return http.get(`configuracao/api/whatsapp/number`);
  }

  updateConfigProtocolChat(data) {
    return apiChatTS.put(
      `configurations/protocolo/criarProtocoloParaConversa`,
      data
    );
  }

  getConfigProtocolChat() {
    return http.get(`configuracao/api/protocolo/criarProtocoloParaConversa`);
  }

  updateTimeForEndConversation(time) {
    return http.put(`configuracao/api/encerramento/tempo`, { time });
  }

  getWaitingTime() {
    return http.get(`configuracao/api/encerramento/tempo`);
  }
}

export default new ConversationReportService();
